module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('form', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "page section-header text-center"
  }, [_c('h1', [_vm._v("EXCHANGE & CANCELLATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "rte"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "custom-content"
  }, [_c('div', {
    staticClass: "custom__item custom__item--1537787486018 one-whole align--center"
  }, [_c('div', {
    staticClass: "medium-up--text-center"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v(" How do I Cancel or Exchange?")]), _vm._v(" "), _c('div', {
    staticClass: "rte-setting"
  }, [_c('p', [_vm._v("\nDrop an Email on talk.lilpicks@gmail.com or whatsApp on 9911437000\n")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v(" What items are non-exchangeable?")]), _vm._v("\nYou can exchange your items within 15 days of receipt of your shipment.\n"), _c('p', [_vm._v("\n* They must be in original condition\n* Must be unwashed and unworn\n* In the original packaging\n* Free gifts or promotional items are non-exchangeable !\n")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v(" Are there any charges for exchange?")]), _vm._v(" "), _c('p', [_vm._v("\n* There are no charges for exchange.\n")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v(" How soon will I get my exchange product?")]), _vm._v(" "), _c('p', [_vm._v("\nOnce your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your exchange. If you are approved, then your exchange will be processed, and mention your exchange items on mail or whatsApp. We will dispatch your product within 2-3 days.\n")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a917a4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/exchangeAndCancellations.vue
// module id = 2249
// module chunks = 0